import {
  Zap,
  PowerOff,
  MoveRight,
  CreditCard,
  Settings,
  AlertTriangle,
  PhoneCall,
} from "lucide-react";
import { SERVICES, PHONE_DISPLAY, PHONE_TEL } from "@/lib/site-content";

const ICONS = {
  Zap,
  PowerOff,
  MoveRight,
  CreditCard,
  Settings,
  AlertTriangle,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-20 sm:py-28 lg:py-32 border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16">
          <div className="lg:col-span-8">
            <p className="label-eyebrow mb-4">Our Services</p>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-zinc-900 leading-[1.02] tracking-tighter">
              Every utility request,
              <br />
              <span className="text-[#FF4500]">one phone number.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 flex lg:items-end">
            <p className="text-zinc-600 text-base leading-relaxed">
              Whether you're moving in, moving out, paying a bill or reporting
              an outage — Specpay Solutions handles it end-to-end. Tap any tile
              to call.
            </p>
          </div>
        </div>

        {/* Tetris-style asymmetric grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon];
            // Tetris layout: large card spans 8 cols, others span 4
            const span = idx === 0 ? "md:col-span-8" : "md:col-span-4";
            const isLarge = idx === 0;

            return (
              <a
                key={s.id}
                href={PHONE_TEL}
                data-testid={`service-card-${s.id}`}
                className={`group ${span} relative bg-white border border-zinc-200 hover:border-zinc-900 p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex flex-col ${
                  isLarge ? "min-h-[260px] sm:min-h-[300px]" : "min-h-[220px]"
                }`}
              >
                <div
                  className="w-12 h-12 flex items-center justify-center mb-5"
                  style={{ backgroundColor: s.accent, color: "#fff" }}
                >
                  <Icon className="w-6 h-6" strokeWidth={2.5} />
                </div>

                <h3
                  className={`font-display font-black tracking-tight text-zinc-900 ${
                    isLarge ? "text-3xl sm:text-4xl" : "text-xl sm:text-2xl"
                  }`}
                >
                  {s.title}
                </h3>
                <p className="mt-3 text-zinc-600 text-sm sm:text-base leading-relaxed flex-1">
                  {s.desc}
                </p>

                <div className="mt-6 inline-flex items-center gap-2 font-display font-bold text-sm text-zinc-900 group-hover:text-[#FF4500] transition-colors">
                  <PhoneCall className="w-4 h-4" strokeWidth={2.5} />
                  Call {PHONE_DISPLAY}
                </div>

                <span className="absolute top-6 right-6 label-eyebrow text-zinc-300">
                  0{idx + 1}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
